<template id="templateSchedule">
  <div>
<!--    <select class="form-control form-control-sm " v-model="selectedValue" v-on:change="copyPreviousScheduleShifts">-->
    <select class="form-control form-control-sm text-capitalize" v-model="selectValue" v-on:change="copyPreviousScheduleShifts">
      <option disabled  selected value="0">Copy from previous schedules</option>
      <option v-for="item in previousSchedule" :value="item.id" :title="item.name" class="text-capitalize">
        {{(item.name)?item.name:'Unnamed'}} - {{ item.start_date | moment("DD MMM YY") }} ~ {{ item.end_date | moment("DD MMM YY") }}
      </option>
    </select>
  </div>
</template>
<script>
// window['moment-range'].extendMoment(moment);
import Moment from 'moment';
import {extendMoment} from 'moment-range';
import Swal from "sweetalert2";

const moment = extendMoment(Moment);

export default {
  data() {
    return {
      selectValue: '0',
      selectedValue: '',
    }
  },
  props: ["previousSchedule"],

  methods: {
    // start date
    copyPreviousScheduleShifts(event) {
      new Swal({
        title: "Copy schedule?",
        icon: "warning",
        text: "Do you really want to copy from previous schedules?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes"
      }).then((result) => {
        if (result.value) {
          this.selectedValue=event.target.value;
          this.$emit('selectedRosterScheduleId', this.selectedValue);
        }else{
          this.selectValue='0';
        }
      })



    }


  }
}


</script>



